import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewEncapsulation, } from '@angular/core';
import swal from 'sweetalert2';
import { AppService } from 'src/app/core/services/app.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { Location } from '@angular/common';
import { SwalService } from 'src/app/core/services/swal.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { EncodingDataService } from 'src/app/core/services/encoding-data.service';
import { SharedDataService } from 'src/app/core/services/shared-data.service';
import { EventEmitterService } from 'src/app/core/services/event-emitter.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-fiche-evaluation-historique',
  templateUrl: './fiche-evaluation-historique.component.html',
  styleUrls: ['./fiche-evaluation-historique.component.css']
})
export class FicheEvaluationHistoriqueComponent implements OnInit {

  public COMPETITIVITE: any;
  public FORMATION: any;
  public AUTRE_FORMATION: any;
  public CARRIERE: any;
  public COMMUNICATION: any;
  public COMPETENCES: any;
  public MAITRISE_POSTE: any;
  public MANAGEMENT: any;
  public SYNTHESE_GLOBALE: any;
  public OBJECTIF_ANNEE_COURS: any;
  public OBJECTIF_ANNEE_SUIVANTE: any;
  public PERFORMANCE: any;
  public VALEURS: any;
  public QSSE: any;
  public RESULTATS: any;
  public APPRECIATION: any;
  public historique: any;
  public response: any;
  public isFullscreen = false;
  public date_debut: any;
  public date_fin: any;
  public loaderText: any;
  public listFiche: any;
  public nom: string;
  public prenoms: string;
  public structure: string;
  public poste: string;
  public matricule: any;
  public listEvaluation: any;
  public libelle_campagne: any;
  public status_campagne: any;
  public entretien_id: string;
  public agent_id: string;
  public typeVisualisation: any;
  public typeFiche: any;
  public typeSauvegarde: any;
  public vueActive: any;
  public libelleFiche: any;
  public resultat_tenue_poste: any;
  public resultat_savoir_etre: any;
  public resultat_savoir_faire: any;
  public appreciation_tenue_poste: any;
  public nbre_rubrique_evaluee_global: any;
  public statut: any;

  constructor(
    // tslint:disable-next-line: max-line-length
    private _service: AppService,
    private sharedService: SharedDataService,
    private _loading: LoadingBarService,
    private toastrService: ToastrService,
    private _location: Location,
    private _swal: SwalService,
    private _spinner: NgxSpinnerService,
    private _router: Router,
    private eventEmitter: EventEmitterService,
    private elRef: ElementRef, private renderer: Renderer2,
    private storage: EncodingDataService,
  ) { }

  toggleFullscreen() {
    const card = this.elRef.nativeElement.querySelector('.card');
    if (this.isFullscreen) {
      this.renderer.removeClass(document.body, 'fullscreen');
    } else {
      this.renderer.addClass(document.body, 'fullscreen');
    }
    this.isFullscreen = !this.isFullscreen;
  }

  @HostListener('window:keydown.escape')
  exitFullscreen() {
    if (this.isFullscreen) {
      this.toggleFullscreen();
    }
  }

  public getStatusClasses(statut: string): { [key: string]: boolean } {
    return {
      'badge-info': statut === 'initialisé' || statut === 'soumis' || statut === 'appliqué' || statut === 'analysé',
      'badge-danger': statut === 'archivé' || statut === 'retourné' || statut === 'fermé',
      'badge-success': statut === 'arbitré' || statut === 'traité',
      'badge-warning': statut === 'en attente',
      'badge-valide': statut === 'validé',
      'badge-effectue': statut === 'effectué' || statut === 'démarré',
      'badge-accepte': statut === 'accepté',
      'badge-planifie': statut === 'planifié',
      'badge-approuve': statut === 'approuvé',
      'badge-revus': statut === 'revu',
      'badge-soumis': statut === 'soumis',
      'badge-100': statut !== 'planifié'
    };
  }

  public getUserDetails(id): void {
    this._loading.start();
    this._service.getData('gestion-evaluations/fiche/' + id)
      .subscribe(
        res => {
          if (res.error === false) {
            this._loading.stop();
            this.date_debut = res.data.date_debut;
            this.date_fin = res.data.date_fin;
            this.libelle_campagne = res.data.libelle;
            this.status_campagne = res.data.status_campagne;
            this.getStatusClasses(this.status_campagne);
            this.nom = res.data.nom;
            this.prenoms = res.data.prenoms;
            this.matricule = res.data.matricule;
          } else {
            this._loading.stop();
            this._swal.error(res.message);
          }
        }, err => {
          this._loading.stop();
          this.toastrService.error(err.error.message);
        }
      );
  }

  public closeFicheEvaluation(): void {
    swal
      .fire({
        title: 'En êtes vous sûr?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#FD7E14',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Annuler',
        confirmButtonText: 'Oui, je confirme',
      })
      .then((result) => {
        if (result.value) {
          this._location.back();
        }
      });
  }

  public ngOnInit(): void {
    const url = window.location.href;
    const split_url = url.split('/');
    this.vueActive = split_url[4];
    this.entretien_id = split_url[6];
    this.agent_id = split_url[7];
    this.typeFiche = split_url[9];
    this.typeSauvegarde = split_url[11];
    this.typeVisualisation = split_url[12];
    this.statut = split_url[14];
    // console.log('URL IS :', url);
    // console.log('typeFiche IS :', this.typeFiche);
    // console.log('typeSauvegarde IS :', this.typeSauvegarde);
    // console.log('typeVisualisation IS :', this.typeVisualisation);
    // console.log('statut IS :', this.statut);
    // console.log('vueActive IS :', this.vueActive);
    // console.log('entretien_id IS :', this.entretien_id);
    // console.log('agent_id IS :', this.agent_id);
    this.libelleFiche = 'HISTORIQUE FICHE D\'EVALUATION';
    this.getUserDetails(this.entretien_id);
    this.response = this.storage.getData('historique')
    this.GetRowHistorique();
  }

  public GetRowHistorique(): void {

    // console.log('FICHE:', data);

    this.historique = this.response ?? "{}"
    const parsed = JSON.parse(this.historique)
    const resultats = parsed?.resultats

    this.RESULTATS = {
      resultat_global: resultats?.resultat_global,
      appreciation_global: resultats?.appreciation_global,

      synthese_competence_tt: JSON.parse(resultats?.synthese_competence),
      synthese_performance_tt: JSON.parse(resultats?.synthese_performance),
      synthese_savoir_faire_tt: JSON.parse(resultats?.synthese_savoir_faire),
      synthese_savoir_etre_tt: JSON.parse(resultats?.synthese_savoir_etre),

      communication: {
        resultat_communication: resultats?.resultat_communication,
        appreciation_communication: resultats?.appreciation_communication,
      },

      competitivite: {
        resultat_competitivite: resultats?.resultat_competitivite,
        appreciation_competitivite: resultats?.appreciation_competitivite
      },

      maitrise_poste: {
        resultat_maitrise_poste: resultats?.resultat_maitrise_poste,
        appreciation_maitrise_poste: resultats?.appreciation_maitrise_poste
      },

      management: {
        resultat_management: resultats?.resultat_management,
        appreciation_management: resultats?.appreciation_management
      },

      objectif_annee_encours: {
        resultat_objectif_annee_encours: resultats?.resultat_objectif_annee_encours,
        appreciation_objectif_annee_encours: resultats?.appreciation_objectif_annee_encours
      },

      performance: {
        resultat_performance: resultats?.resultat_performance,
        appreciation_performance: resultats?.appreciation_performance
      },

      qsse: {
        resultat_qsse: resultats?.resultat_qsse,
        appreciation_qsse: resultats?.appreciation_qsse
      },

      savoir_etre: {
        resultat_savoir_etre: resultats?.resultat_savoir_etre,
        appreciation_savoir_etre: resultats?.appreciation_savoir_etre
      },

      savoir_faire: {
        resultat_savoir_faire: resultats?.resultat_savoir_faire,
        appreciation_savoir_faire: resultats?.appreciation_savoir_faire
      },

      synthese_competence: {
        resultat_synthese_competence: resultats?.resultat_synthese_competence,
        appreciation_synthese_competence: resultats?.appreciation_synthese_competence
      },

      synthese_performance: {
        resultat_synthese_performance: resultats?.resultat_synthese_performance,
        appreciation_synthese_performance: resultats?.appreciation_synthese_performance
      },

      valeur: {
        resultat_valeur: resultats?.resultat_valeur,
        appreciation_valeur: resultats?.appreciation_valeur
      },
    }
    // console.log('RESULTATS:', this.RESULTATS);

    this.COMPETITIVITE = JSON.parse(resultats?.competitivite ?? "{}");
    this.FORMATION = JSON.parse(resultats?.formations ?? "{}");
    this.AUTRE_FORMATION = JSON.parse(resultats?.formation_autres ?? "{}");
    this.CARRIERE = JSON.parse(resultats?.carriere ?? "{}");
    this.COMMUNICATION = JSON.parse(resultats?.communication ?? "{}");
    this.COMPETENCES = JSON.parse(resultats?.competences ?? "{}");
    this.MAITRISE_POSTE = JSON.parse(resultats?.maitrise_poste ?? "{}");
    this.MANAGEMENT = JSON.parse(resultats?.management ?? "{}");
    this.OBJECTIF_ANNEE_COURS = JSON.parse(resultats?.objectif_annee_encours ?? "{}");
    this.OBJECTIF_ANNEE_SUIVANTE = JSON.parse(resultats?.objectif_annee_suivant ?? "{}");
    this.PERFORMANCE = JSON.parse(resultats?.performance ?? "{}");
    this.QSSE = JSON.parse(resultats?.qsse ?? "{}");
    this.VALEURS = JSON.parse(resultats?.valeur ?? "{}");
    this.SYNTHESE_GLOBALE = JSON.parse(this.historique ?? "{}");

    this.resultat_tenue_poste = this.RESULTATS?.synthese_competence_tt?.note
    this.nbre_rubrique_evaluee_global = this.RESULTATS?.synthese_competence_tt?.nbre
    this.appreciation_tenue_poste = this.RESULTATS?.synthese_competence?.appreciation_synthese_competence
    this.resultat_savoir_etre = this.RESULTATS?.synthese_savoir_etre_tt?.note
    this.resultat_savoir_faire = this.RESULTATS?.synthese_savoir_faire_tt?.note

    // console.log('COMPETITIVITE:', this.COMPETITIVITE);
    // console.log('FORMATION:', this.FORMATION);
    // console.log('AUTRE_FORMATION:', this.AUTRE_FORMATION);
    // console.log('CARRIERE:', this.CARRIERE);
    // console.log('COMMUNICATION:', this.COMMUNICATION);
    // console.log('COMPETENCES:', this.COMPETENCES);
    // console.log('MAITRISE_POSTE:', this.MAITRISE_POSTE);
    // console.log('MANAGEMENT:', this.MANAGEMENT);
    // console.log('OBJECTIF_ANNEE_COURS:', this.OBJECTIF_ANNEE_COURS);
    // console.log('OBJECTIF_ANNEE_SUIVANTE:', this.OBJECTIF_ANNEE_SUIVANTE);
    // console.log('PERFORMANCE:', this.PERFORMANCE);
    // console.log('QSSE:', this.QSSE);
    // console.log('VALEURS:', this.VALEURS);
    // console.log('SYNTHESE_GLOBALE:', this.SYNTHESE_GLOBALE);

  }



}
